(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/definitions.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/definitions.js');

'use strict';

var _svs;
const isPnp = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 || (_svs = _svs.site) === null || _svs === void 0 ? void 0 : _svs.toLowerCase()) === 'momang';
const LoginTypes = {
  DESKTOP_BANKID_MOBILE_QR: 1,
  DESKTOP_BANKID_MOBILE_SSN: 2,
  DESKTOP_BANKID: 3,
  DESKTOP_FREJA: 4,
  DESKTOP_FREJA_SAME_DEVICE: 5,
  MOBILE_BANKID: 6,
  MOBILE_FREJA: 7
};
const LoginMethods = {
  BANKID: 1,
  FREJA: 2
};
const CONFIG = {
  POLL_INTERVAL: 1000,
  INITIAL_POLL_DELAY: 500,
  CANCEL_CUTOFF: 4000,
  POLLING_DELTA_CUTOFF: 2000,
  ERROR_RETRIES: 2,
  QR_TIMEOUT_RETRIES: {
    BANKID: 10,
    FREJA: 1
  }
};
const TimeoutTypes = {
  BANKID_SSN: '1',
  BANKID: '2',
  FREJA: '3',
  BANKID_IOS: '4'
};
const LoginTokenTTL = {
  [TimeoutTypes.BANKID_SSN]: 180 * 1000,
  [TimeoutTypes.BANKID_IOS]: 180 * 1000,
  [TimeoutTypes.BANKID]: 30 * 1000,
  [TimeoutTypes.FREJA]: 120 * 1000
};
const Events = {
  READY_TO_POLL: 'READY_TO_POLL',
  STATUS_UPDATE: 'STATUS_UPDATE',
  NEW_CUSTOMER: 'NEW_CUSTOMER',
  ERROR: 'ERROR',
  LOGIN: 'LOGIN',
  SIGN: 'SIGN',
  NOT_STARTED: 'NOT_STARTED',
  NOT_POLLING: 'NOT_POLLING',
  NO_RESUME: 'NO_RESUME',
  CANCELLED: 'CANCELLED',
  RETRIES_FINISHED: 'RETRIES_FINISHED',
  RETRY: 'RETRY',
  ALREADY_POLLING: 'ALREADY_POLLING',
  TIMEOUT_TYPE_UPDATED: 'TIMEOUT_TYPE_UPDATED',
  QR_UPDATE: 'QR_UPDATE',
  ONE_RETRY_LEFT: 'ONE_RETRY_LEFT',
  UPDATE_PARENT_URL: 'UPDATE_PARENT_URL'
};
const ErrorTypes = {
  FREJA_NEW_CUSTOMER: 'FREJA_NEW_CUSTOMER',
  BANKID_APP_NOT_RESPONDING: 'BANKID_APP_NOT_RESPONDING',
  BANKID_UPDATE_APP: 'BANKID_UPDATE_APP',
  BANKID_EXPIRED: 'BANKID_EXPIRED',
  LOGIN_CANCELLED: 'LOGIN_CANCELLED',
  LOGIN_USER_ABORTED: 'LOGIN_USER_ABORTED',
  CANNOT_LOGIN: 'CANNOT_LOGIN',
  CANNOT_LOGIN_CONTACT: 'CANNOT_LOGIN_CONTACT',
  SPELPAUS_DOWN: 'SPELPAUS_DOWN',
  UNHANDLED: 'UNHANDLED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  MULTIPLE_LOGINS: 'MULTIPLE_LOGINS',
  CANNOT_GET_TOKEN: 'CANNOT_GET_TOKEN',
  CANNOT_CANCEL: 'CANNOT_CANCEL',
  BANKID_UPDATE_ID: 'BANKID_UPDATE_ID',
  GENERAL: 'GENERAL',
  GENERAL_BANKID: 'GENERAL_BANKID',
  INVALID_TOKEN: 'INVALID_TOKEN',
  NOT_LOGGED_IN: 'NOT_LOGGED_IN'
};
const BankidStatus = {
  DELIVERED_TO_MOBILE: 4,
  NEW_CUSTOMER: 20,
  NEW_RETAILER_CUSTOMER: 21,
  RETURNING_CUSTOMER: 22
};
const FrejaStatus = {
  STARTED: 1,
  DELIVERED_TO_MOBILE: 2,
  CANCELED: 3,
  RP_CANCELED: 4,
  EXPIRED: 5,
  APPROVED: 6,
  REJECTED: 7
};
const Source = {
  'ios-hybrid-mobile': 5,
  'android-hybrid-mobile': 5,
  'ios-hybrid-tablet': 6,
  'web-mobile': isPnp ? 17 : 1,
  'web-tablet': isPnp ? 18 : 2,
  'web-desktop': isPnp ? 16 : 3,
  'poker-desktop': 4,
  'poker-mobile': 10
};
const api = {
  LoginTypes,
  LoginMethods,
  Events,
  ErrorTypes,
  Source,
  TimeoutTypes,
  LoginTokenTTL,
  FrejaStatus,
  BankidStatus,
  CONFIG
};
if (typeof exports === 'object') {
  module.exports = api;
} else {
  svs.accountservices.authenticate.definitions = api;
}

 })(window);